exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dark-fill[data-v-491f7bca] {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n.mb-w-50[data-v-491f7bca] {\n  width: 50%;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n.mb-w-50[data-v-491f7bca] {\n    width: 100%;\n}\n}\n", ""]);

// exports
